// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('support.supportcases.updateinventorystatus', {
        url:'/updateinventorystatus',
        views: {
            'supportView@support': {
            templateUrl: 'main/support/supportcases/updateinventorystatus/updateinventorystatus.tpl.html',
            controller: 'SupportCaseUpdateInventoryStatusController as vm'
        }},
        resolve: {
        }
    });
}

// @ngInject
function SupportCaseUpdateInventoryStatusController($state, $scope, SupportApiService, InventoryingApiService, loadSpinnerService, ToasterService, confirmationDialogService, $translate) {
    var vm = this;

    //Properties
    vm.isEditing = false;
    vm.selectedInventory = {};
    /*
        Created,
        FileImported,
        Pending,
        Completed,
        Deleted
    */
    vm.selectedInventoryStatus = '';
    vm.inventoryStatuses = [
        { id: 0, statusName: 'Created', value: 'created' },
        { id: 1, statusName: 'FileImported', value: 'fileImported' },
        { id: 2, statusName: 'Pending', value: 'pending' },
        { id: 3, statusName: 'Completed', value: 'completed' },
        { id: 4, statusName: 'Deleted', value: 'deleted' }
    ];
    vm.inventories = [];
    vm.currentPage = 1;
    vm.itemsPerPage = 10;
    vm.totalItems = 0;
    vm.searchTerm = '';

    //Methods
    vm.selectInventory = selectInventory;
    vm.isAllowedToSave = isAllowedToSave;
    vm.startEditing = startEditing;
    vm.saveChange = saveChange;
    vm.cancelEditing = cancelEditing;
    vm.searchTermChange = searchTermChange;

    activate();

    function activate() {
        loadInventories();
    }

    function loadInventories() {
        loadSpinnerService.start('mainSpinner');
        InventoryingApiService.getAll(vm.currentPage, vm.searchTerm, vm.itemsPerPage).then(function(response) {
            vm.inventories = response.data;
            vm.totalItems = response.totalItems;
            formatPlannedDeliveryDate(vm.inventories);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner', {force: true});
        });
    }
    function searchTermChange() {
        loadInventories();
    }

    function formatPlannedDeliveryDate(orders) {
        for (var i = 0; i < orders.length; i++) {
            var order = orders[i];
            order.inventoryDate = order.inventoryDate.split('T')[0];
        }
    }

    function startEditing() {
        vm.isEditing = true;
    }
    function saveChange() {
        confirmationDialogService.showDialog('<div>' + $translate.instant("support.confirmUpdateData") + '</div>').then(function (result) {
            if (result === true) {
                loadSpinnerService.start("mainSpinner");
                SupportApiService.updateInventoryStatus({ inventoryId: vm.selectedInventory.id, status: vm.selectedInventoryStatus.value }).then(function(response) {
                    cancelEditing();
                    loadInventories();
                    ToasterService.showSuccess($translate.instant('support.isInventoryStatusChanged'), $translate.instant('support.supportCase'));
                }, function(error) {
                    var message = error.message + '\n';
                    _.forEach(error.errors, function(err) {
                        message += err.message + '\n';
                    });
                    ToasterService.showError(message, $translate.instant('common.error'));
                }).finally(function() {
                    loadSpinnerService.stop("mainSpinner");
                });
            }
        });
    }
    function cancelEditing() {
        vm.isEditing = false;
        vm.selectedInventoryStatus = '';
        vm.selectedInventory = {};
    }

    function selectInventory(inventory) {
        vm.selectedInventory = inventory;
    }

    function isAllowedToSave() {
        var hasSelectedInventory = vm.selectedInventory && vm.selectedInventory.id > 0;
        var hasSelectedInventoryStatus = vm.selectedInventoryStatus && vm.selectedInventoryStatus.id > 0;
        return hasSelectedInventory && hasSelectedInventoryStatus;
    }
}

angular
    .module('supportcases.updateinventorystatus', ['support.api'])
    .config(stateConfig)
    .controller('SupportCaseUpdateInventoryStatusController', SupportCaseUpdateInventoryStatusController);
